import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import styled from "styled-components";
import AdminBoardService from "../../service/AdminBoardService";
import Button from "../atom/Button";
import SelectBox from "../atom/SelectBox";
import TitleHeader from "../modecules/TitleHeader";

// import { myAssignPerson } from "../AssignPersonState";
// import { useRecoilValue } from "recoil";

const AdminVocDtailWrap = styled.div`
  margin-top: 50px;
  width: 60%;
  @media ${(props) => props.theme.device.laptop} {
    width: 80%;
  }
`;

const AdminVocDetailBoardView = styled.div``;

const AdminDetailNumber = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 50px;
  color: #388fc0;
  font-weight: 800;
`;

const AdminDetailBoardViewTop = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #388fc0;
  padding-bottom: 17px;
  @media ${(props) => props.theme.device.tablet} {
    flex-direction: column;
    justify-content: center;
  }
`;

const AdminVocDetailBoardViewTitle = styled.div`
  font-size: 22px;
  color: #666;
  font-weight: 600;
  min-width: 150px;
`;

const AdminVocDetailBoardViewCnt = styled.div`
  display: flex;
  align-items: center;
  @media ${(props) => props.theme.device.tablet} {
    flex-direction: column;
  }
`;

const CntUsername = styled.div`
  font-size: 17px;
  color: #888;
  margin-left: 17px;
  font-weight: 400;
  @media ${(props) => props.theme.device.mobile} {
    font-size: 12px;
  }
`;

const CntDate = styled.div`
  font-size: 17px;
  color: #888;
  margin-left: 17px;
  font-weight: 400;
  @media ${(props) => props.theme.device.mobile} {
    font-size: 12px;
  }
`;
const AdminVocDetailPhoneNumber = styled.div`
  font-size: 22px;
  font-weight: 500;
  margin-top: 10px;
  color: #666;
`;

const AdminVocDetailBoardViewContent = styled.div`
  width: 100%;
  font-size: 18px;
  font-weight: 500;
  color: #666;
  line-height: 1.4;
  min-height: 400px;
  margin-top: 20px;
  white-space: pre-wrap;
  padding-bottom: 30px;
  word-break: break-all;
`;

const AdminVocDetailBoardViewFile = styled.div`
  display: flex;
  align-items: center;
`;

const AdminVocDetailBoardViewFileLine = styled.div`
  border-bottom: 2px solid #dcdcdc;
  padding-bottom: 17px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  @media ${(props) => props.theme.device.tablet} {
    flex-direction: column;
  }
`;

const AdminDetailFileWrap = styled.div`
  display: flex;
  @media ${(props) => props.theme.device.tablet} {
    margin-bottom: 20px;
  }
`;
const AdminVocServiceWrap = styled.div`
  display: flex;
  align-items: center;
`;

const AdminVocDetailBoardViewFileTitle = styled.label`
  font-size: 20px;
  color: #666;
  font-weight: 600;
  margin-right: 12px;
`;

const AdminVocDetailBoardViewFilename = styled.label`
  font-size: 16px;
  color: #888;
  &:hover {
    font-size: 16px;
    color: #888;
    cursor: pointer;
    border-bottom: 1px solid black;
  }
`;

const AdminVocDetailBoardViewOrigin = styled.label`
  font-size: 20px;
  color: #666;
  font-weight: 600;
  margin-right: 12px;
`;

const AdminVocDetailBoardViewOriginCnt = styled.label`
  font-size: 16px;
  color: #888;
  width: 100px;
`;

const AdminVocDetailButton = styled.div`
  display: flex;
  justify-content: space-between;
  @media ${(props) => props.theme.device.tablet} {
    flex-direction: column;
  }
`;

const AdminVocWritePageRegistBtn = styled.div`
  display: flex;
  justify-content: space-between;
  @media ${(props) => props.theme.device.tablet} {
    margin-top: 10px;
  }
`;

const AdminSelectBoxWrap = styled.div`
  font-size: 16px;
  display: flex;
`;

const AdminVocDetailPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [item, setItem] = useState({});
  const [selectAssignPerson, setSelectAssignPerson] = useState();
  const [selectAssignPersonName, setSelectAssignPersonName] = useState();

  const assignPerson = JSON.parse(localStorage.getItem("assingPersonList"));
  // console.log("assignPerson", assignPerson);
  // console.log("selectAssignPerson", selectAssignPerson);
  // console.log("selectAssignPersonName", selectAssignPersonName);
  // console.log(item);
  useEffect(() => {
    if (sessionStorage.getItem("isAdmin") !== "true") {
      alert("로그인해주시기 바랍니다.");
      navigate("/AdminVocLogin");
    }
  }, [navigate]);

  const handleSelectBox = (assignID) => {
    // console.log('assignID', assignID);
    setSelectAssignPerson(assignID);
  };

  const handleSelectBoxName = (assignName) => {
    // console.log('assignID', assignName);
    setSelectAssignPersonName(assignName);
  };

  // console.log("2", selectAssignPerson);
  useEffect(() => {
    // console.log("리스트에서 클릭시 해당 페이지 데이터", location.state);
    setItem(location.state);
  }, [location]);

  const navigateToList = () => {
    navigate(-1);
  };

  const handleClickBtn = async (param) => {
    // console.log("param", param);
    if (param === "1" && selectAssignPerson === undefined) {
      alert("조치담당자를 설정해주세요 설정되지 않았습니다.");
      return;
    } else {
      const response = await AdminBoardService.updateAdminVoc(
        item.No,
        param,
        selectAssignPerson,
        selectAssignPersonName,
        item.ServiceSortation
      );
      // console.log(response);
      if (response.status === "success") {
        navigate("/AdminVocBoard");
      }
    }
  };
  const downloadFile = async () => {
    const response = await AdminBoardService.fileDownload(item.No);
    if (response.status === "success") {
    }
  };

  return (
    <AdminVocDtailWrap>
      <TitleHeader title={"접수페이지"} subTitle={"관리자용 고객 VOC 상세내역입니다. 승인 상태를 확인해 주세요."} />
      <AdminVocDetailBoardView>
        <AdminDetailNumber>No.{item.No}</AdminDetailNumber>
        <AdminDetailBoardViewTop>
          <AdminVocDetailBoardViewTitle>제목 : {item.Title}</AdminVocDetailBoardViewTitle>
          <AdminVocDetailBoardViewCnt>
            <AdminSelectBoxWrap>
              <p>담당자 배정:</p>
              {item.Status === "접수" ? (
                <div>{item.EmpNm}</div>
              ) : item.Status === "삭제" ? (
                <div>{item.EmpNm}</div>
              ) : item.Status === "종료" ? (
                <div>{item.EmpNm}</div>
              ) : (
                <SelectBox
                  selectLists={assignPerson}
                  handleSelectBox={handleSelectBox}
                  handleSelectBoxName={handleSelectBoxName}
                />
              )}
            </AdminSelectBoxWrap>
            <CntUsername>작성자 | {item.Name}</CntUsername>
            <CntDate>작성일자 | {item.Date}</CntDate>
          </AdminVocDetailBoardViewCnt>
        </AdminDetailBoardViewTop>
        <AdminVocDetailPhoneNumber>▶ 등록자 연락처: {item.PhoneNumber}</AdminVocDetailPhoneNumber>
        <AdminVocDetailBoardViewContent>{item.Content}</AdminVocDetailBoardViewContent>
        <AdminVocDetailBoardViewFile>
          <AdminVocDetailBoardViewFileLine>
            <AdminDetailFileWrap>
              <AdminVocDetailBoardViewFileTitle>첨부파일</AdminVocDetailBoardViewFileTitle>
              <AdminVocDetailBoardViewFilename onClick={downloadFile}>
                {!!item.FileOriginName && item.FileOriginName !== "undefined" && item.FileOriginName !== "null"
                  ? item.FileOriginName
                  : "첨부파일 없음"}
              </AdminVocDetailBoardViewFilename>
            </AdminDetailFileWrap>
            <AdminVocServiceWrap>
              <AdminVocDetailBoardViewOrigin>서비스 분류</AdminVocDetailBoardViewOrigin>
              <AdminVocDetailBoardViewOriginCnt>
                {!!item.ServiceSortation && item.ServiceSortation === "01"
                  ? "인트라넷"
                  : item.ServiceSortation === "02"
                  ? "싸다오"
                  : item.ServiceSortation === "03"
                  ? "아레오"
                  : item.ServiceSortation === "04"
                  ? "네띠앙"
                  : item.ServiceSortation === "05"
                  ? "서울이동통신"
                  : item.ServiceSortation === "06"
                  ? "스탠다드 네트웍스"
                  : item.ServiceSortation === "07"
                  ? "업체문의"
                  : item.ServiceSortation === "08"
                  ? "고객사"
                  : item.ServiceSortation === "09"
                  ? "UMS"
                  : item.ServiceSortation === "10"
                  ? "영업부 요청사항"
                  : item.ServiceSortation === "11"
                  ? "Say015&SMART015"
                  : item.ServiceSortation === "null"
                  ? "미분류"
                  : "미분류"}
              </AdminVocDetailBoardViewOriginCnt>
            </AdminVocServiceWrap>
          </AdminVocDetailBoardViewFileLine>
        </AdminVocDetailBoardViewFile>
      </AdminVocDetailBoardView>
      <AdminVocDetailButton>
        <Button
          onClick={navigateToList}
          text={"목록"}
          backgroundColor={"#388fc0"}
          fontColor={"white"}
          borderRadius={"5px"}
        />
        <AdminVocWritePageRegistBtn className="AdminVocWritePageRegistBtn">
          {item.Status === "접수" ? (
            <Button
              onClick={handleClickBtn.bind(this, "5")}
              text={"VOC 종료"}
              backgroundColor={"#388fc0"}
              fontColor={"white"}
              borderRadius={"5px"}
            />
          ) : item.Status === "대기" ? (
            <>
              <Button
                onClick={handleClickBtn.bind(this, "1")}
                text={"VOC 접수"}
                backgroundColor={"#388fc0"}
                fontColor={"white"}
                borderRadius={"5px"}
              />
              <Button
                onClick={handleClickBtn.bind(this, "2")}
                text={"보류"}
                backgroundColor={"#fff"}
                fontColor={"#388fc0"}
                borderRadius={"5px"}
              />
              <Button
                onClick={handleClickBtn.bind(this, "3")}
                text={"삭제"}
                backgroundColor={"#fff"}
                fontColor={"#388fc0"}
                borderRadius={"5px"}
              />
            </>
          ) : item.Status === "종료" ? null : item.Status === "삭제" ? null : location.Status === "보류" ? (
            <>
              <Button
                onClick={handleClickBtn.bind(this, "1")}
                text={"VOC 접수"}
                backgroundColor={"#388fc0"}
                fontColor={"white"}
                borderRadius={"5px"}
              />
              <Button
                onClick={handleClickBtn.bind(this, "2")}
                text={"보류"}
                backgroundColor={"#fff"}
                fontColor={"#388fc0"}
                borderRadius={"5px"}
              />
              <Button
                onClick={handleClickBtn.bind(this, "3")}
                text={"삭제"}
                backgroundColor={"#fff"}
                fontColor={"#388fc0"}
                borderRadius={"5px"}
              />
            </>
          ) : (
            <>
              <Button
                onClick={handleClickBtn.bind(this, "1")}
                text={"VOC 접수"}
                backgroundColor={"#388fc0"}
                fontColor={"white"}
                borderRadius={"5px"}
              />
              <Button
                onClick={handleClickBtn.bind(this, "3")}
                text={"삭제"}
                backgroundColor={"#fff"}
                fontColor={"#388fc0"}
                borderRadius={"5px"}
              />
            </>
          )}
        </AdminVocWritePageRegistBtn>
      </AdminVocDetailButton>
    </AdminVocDtailWrap>
  );
};

export default AdminVocDetailPage;
